/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelModal64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelModal64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <rect
            x="20.5"
            y="24.5"
            width="23"
            height="15"
            rx="0.5"
            stroke="currentColor"
          />
          <g opacity="0.22">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M53 12C54.6569 12 56 13.3431 56 15V49C56 50.6569 54.6569 52 53 52H11C9.34315 52 8 50.6569 8 49V15C8 13.3431 9.34315 12 11 12H53ZM11 13C9.89543 13 9 13.8954 9 15V49C9 50.1046 9.89543 51 11 51H53C54.1046 51 55 50.1046 55 49V15C55 13.8954 54.1046 13 53 13H11Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelModal64Icon.tags = [
  'panel',
  'dialog',
  'modal',
  'add',
  'maximize',
  'container',
  'rectangle',
  'window',
];

AddPanelModal64Icon.category = '64x64 (Add panel)';

AddPanelModal64Icon.iconSize = 64;
